function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['attributes']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8000')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
export default {
  createUseCaseRequest: function createUseCaseRequest(companyCode, technicalName) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(technicalName, "/registration"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  // updateUseCase(companyCode, useCaseId, data = {}) {
  //   const login = loginObj()
  //   const body = { login, ...data }
  //   tasks.lockScreen.lock()
  //   return appApisGTW.patch(`/api/v1/attribute-management/companies/${companyCode}/usecases/${useCaseId}/update`,
  //     body, { headers: { 'Content-Type': 'application/json' }}).then(response => {
  //     return response.data
  //   }).finally(() => { tasks.lockScreen.unlock() })
  // },
  updateStatusUseCase: function updateStatusUseCase(companyCode, useCaseId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/status/update"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateAttributesUseCase: function updateAttributesUseCase(companyCode, useCaseId, denied) {
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    if (denied) {
      return appApisGTW.patch("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/attributes/update?denied=1"), body, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.data;
      }).finally(function () {
        tasks.lockScreen.unlock();
      });
    } else {
      return appApisGTW.patch("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/attributes/update"), body, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.data;
      }).finally(function () {
        tasks.lockScreen.unlock();
      });
    }
  },
  updateUsersUseCase: function updateUsersUseCase(companyCode, useCaseId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/users/update"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  matchPartyId: function matchPartyId(companyCode, useCaseId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/matching/partyid"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  revokeUsersUseCase: function revokeUsersUseCase(companyCode, useCaseId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/users/revoke"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  getUseCasesByCompanyCode: function getUseCasesByCompanyCode(companyCode) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // OK new company code
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases"), params).then(function (response) {
      return response.data;
    });
  },
  getUseCasesByStatusId: function getUseCasesByStatusId(companyCode) {
    var statusId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';
    var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/status/").concat(statusId), {
      params: queryParams
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getOwnerUseCasesByStatus: function getOwnerUseCasesByStatus(statusId) {
    var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return appApisGTW.get("/api/v1/attribute-management/usecases/pmod/status/".concat(statusId), {
      params: queryParams
    }).then(function (response) {
      return response.data;
    });
  },
  getUseCaseById: function getUseCaseById(companyCode, useCaseId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getTablePartitionField: function getTablePartitionField(projectId, datasetId, tableId) {
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/bigquery/projects/".concat(projectId, "/datasets/").concat(datasetId, "/tables/").concat(tableId, "/partition-field"), {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  createSandbox: function createSandbox(companyCode, useCaseId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/sandbox/creation"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  exportSandboxToDigitalAudiences: function exportSandboxToDigitalAudiences(companyCode, useCaseId) {
    var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/exports/audience"), body, {
      params: queryParams
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  getSandboxItems: function getSandboxItems(companyCode, useCaseId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/sandbox-items"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getSandboxItemsAux: function getSandboxItemsAux(companyCode, useCaseId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/sandbox-items-aux"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getSandboxTableSchemaFields: function getSandboxTableSchemaFields(projectId, datasetId, tableName) {
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.get("/api/v1/attribute-management/bigquery/projects/".concat(projectId, "/datasets/").concat(datasetId, "/tables/").concat(tableName, "/schema-fields"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getSandboxSegmentFields: function getSandboxSegmentFields(projectId, datasetId, tableName) {
    var login = loginObj();
    var body = {
      login: login
    };
    return appApisGTW.get("/api/v1/attribute-management/bigquery/projects/".concat(projectId, "/datasets/").concat(datasetId, "/tables/").concat(tableName, "/segment-field"), body).then(function (response) {
      return response.data;
    });
  },
  getAttributeGroupsByOrganization: function getAttributeGroupsByOrganization(companyCode) {
    return appApisGTW.get('/api/v1/attribute-management/attribute-groups/by-organization', {
      params: {
        company_code: companyCode
      }
    }).then(function (res) {
      return res.data;
    });
  },
  getAttributesGroupsItems: function getAttributesGroupsItems(companyCode) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/attribute-groups"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getAttributesGroupsFields: function getAttributesGroupsFields(companyCode, groupId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/attribute-groups/").concat(groupId), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  createAttributeGroup: function createAttributeGroup(companyCode) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("/api/v1/attribute-management/companies/".concat(companyCode, "/attribute-groups/registration"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  updateAttributeGroup: function updateAttributeGroup(companyCode, groupId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.put("/api/v1/attribute-management/companies/".concat(companyCode, "/attribute-groups/").concat(groupId, "/update"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  deleteAttributeGroup: function deleteAttributeGroup(companyCode, groupId) {
    var login = loginObj();
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.delete("/api/v1/attribute-management/companies/".concat(companyCode, "/attribute-groups/").concat(groupId, "/delete"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  getLogs: function getLogs(companyCode, useCaseId, params) {
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/requests/logs"), {
      params: params
    }, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getAttributesByVersion: function getAttributesByVersion(companyCode, useCaseId, lastVersionId) {
    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // OK new company code
    var login = loginObj();
    var body = {
      login: login
    };
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/attribute-version/").concat(lastVersionId), params).then(function (response) {
      return response.data;
    });
  },
  getAttributeRequest: function getAttributeRequest(companyCode, useCaseId) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // OK new company code
    var login = loginObj();
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(useCaseId, "/attribute-request"), params).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getAttributeMasterCatalog: function getAttributeMasterCatalog() {
    return appApisGTW.get('/api/v1/attribute-management/catalogs/attribute-master').then(function (response) {
      return response.data;
    });
  },
  getAttributesBlackList: function getAttributesBlackList() {
    return appApisGTW.get('/api/v1/attribute-management/catalogs/attribute-masked').then(function (response) {
      return response.data;
    });
  },
  postAddAttributeMasterCatalog: function postAddAttributeMasterCatalog() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post('/api/v1/attribute-management/catalogs/attribute-master/registration', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  patchEditAttributeMasterCatalog: function patchEditAttributeMasterCatalog() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var group_id = arguments.length > 1 ? arguments[1] : undefined;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.patch("/api/v1/attribute-management/catalogs/attribute-master/".concat(group_id, "/patch"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  postAddAttributesBlackList: function postAddAttributesBlackList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post('/api/v1/attribute-management/catalogs/attribute-masked/registration', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  postDeleteAttributesBlackList: function postDeleteAttributesBlackList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post('/api/v1/attribute-management/catalogs/attribute-masked/delete', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getExportTypes: function getExportTypes() {
    // OK new company code
    var login = loginObj();
    var body = {
      login: login
    };
    return appApisGTW.get("/api/v1/attribute-management/catalogs/export-type", body).then(function (response) {
      return response.data;
    });
  },
  updateFileAutomation: function updateFileAutomation(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/update_file_automations", data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateTransformedAttributes: function updateTransformedAttributes() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var automate_id = arguments.length > 1 ? arguments[1] : undefined;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.put("/api/v1/attribute-management/attr-transformed-update/".concat(automate_id), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postReadFile: function postReadFile() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var companyCode = arguments.length > 1 ? arguments[1] : undefined;
    var usecase_id = arguments.length > 2 ? arguments[2] : undefined;
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/companies/".concat(companyCode, "/usecases/").concat(usecase_id, "/read-file"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getLogStatus: function getLogStatus(id) {
    var login = loginObj();
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/catalogs/attr-automate-status?automate_id=".concat(id), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getAttributeAutomateHist: function getAttributeAutomateHist(id) {
    var login = loginObj();
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/attribute-automate-hist/".concat(id)).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateTransformedEnv: function updateTransformedEnv() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/usecase/transformed_attribute/environment_update", body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getProductizeHistory: function getProductizeHistory() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/catalogs/attr-automate-detail", params).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getProductizeDetail: function getProductizeDetail() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var project_id = arguments.length > 1 ? arguments[1] : undefined;
    var segment_id = arguments.length > 2 ? arguments[2] : undefined;
    var type_export_id = arguments.length > 3 ? arguments[3] : undefined;
    var login = loginObj();
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/usecase/".concat(project_id, "/segment/").concat(segment_id, "/type_export/").concat(type_export_id, "/ucase_attr_aut_detail")).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getIbkAwsSchemes: function getIbkAwsSchemes() {
    var lock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var login = loginObj();
    if (lock) tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/ibk_aws_schemes").then(function (response) {
      if (lock) tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postApproveProductize: function postApproveProductize() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/execute_create_automations", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  patchUpdateProductize: function patchUpdateProductize() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var project_id = arguments.length > 1 ? arguments[1] : undefined;
    var segment_id = arguments.length > 2 ? arguments[2] : undefined;
    var type_export_id = arguments.length > 3 ? arguments[3] : undefined;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/usecase/".concat(project_id, "/segment/").concat(segment_id, "/type_export/").concat(type_export_id, "/status_automate/update"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postSaveProductize: function postSaveProductize() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id_sandbox = arguments.length > 1 ? arguments[1] : undefined;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/usecases/".concat(id_sandbox, "/attr-automate-register"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postSaveTransformedAttributes: function postSaveTransformedAttributes() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id_sandbox = arguments.length > 1 ? arguments[1] : undefined;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/usecases/".concat(id_sandbox, "/attr-transformed-register"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postSaveTransformedAttributesBinning: function postSaveTransformedAttributesBinning() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/export_transformed_attributes_binning", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postSaveTransformedAttributesPeriod: function postSaveTransformedAttributesPeriod() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id_sandbox = arguments.length > 1 ? arguments[1] : undefined;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/usecases/".concat(id_sandbox, "/attr-transformed-period"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postSaveTransformedAttributesPeriodBinning: function postSaveTransformedAttributesPeriodBinning() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/export_transformed_attributes_period_binning", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postAproveTransformedAttributes: function postAproveTransformedAttributes() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/exec_create_transformed_automations", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postTableIdAutomate: function postTableIdAutomate() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // OK new company code
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/validate_tableid_automate", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postValidateAprovedTable: function postValidateAprovedTable() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/validate_approved_tables_psand", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postExecuteApprovedAutomations: function postExecuteApprovedAutomations() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/execute_approved_automations", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postIbkExportSandboxToAws: function postIbkExportSandboxToAws() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/ibk_export_sandbox_to_aws", body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  ListIbkExportSandboxToAws: function ListIbkExportSandboxToAws(id_sandbox) {
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/ibk_list_sandbox_to_aws_exports/".concat(id_sandbox)).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  ListUseCaseViewColumns: function ListUseCaseViewColumns(id_sandbox) {
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/usecase/".concat(id_sandbox, "/list_views_columns")).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  // > exportaciones base (desencriptar id_sandbox): listado por caso de uso (tab)
  ListBaseExports: function ListBaseExports(id_sandbox) {
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/attribute-management/usecases/".concat(id_sandbox, "/base-exports")).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  // > exportaciones base pendientes de aprobación (gestionar solicitudes)
  ListPendingBaseExports: function ListPendingBaseExports(company_code) {
    var business_unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    tasks.lockScreen.lock();
    var params = {};
    if (company_code) params.company_code = company_code;
    if (business_unit) params.business_unit = business_unit;
    return appApisGTW.get("/api/v1/attribute-management/base-exports/pending", {
      params: params
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  ApproveBaseExport: function ApproveBaseExport(export_id) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/base-exports/".concat(export_id, "/approve"), data).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  RejectBaseExport: function RejectBaseExport(export_id) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/base-exports/".concat(export_id, "/reject"), data).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  // > solicitudes de "agregar base" que quedaron esperando decisión del admin porque no
  //   superaron la validación 1:1. No viven en attribute_base_export (esa tabla es exclusiva
  //   de exportar base): el backend deriva el estado del historial del caso de uso.
  GetPendingBaseRequest: function GetPendingBaseRequest(usecase_id) {
    return appApisGTW.get("/api/v1/attribute-management/usecases/".concat(usecase_id, "/base-request/pending")).then(function (response) {
      return response.data;
    });
  },
  // login obligatorio: el backend valida el rol real del aprobador (aprobar omite la
  // validación 1:1, así que no puede depender de una bandera del frontend)
  ApprovePendingBaseRequest: function ApprovePendingBaseRequest(usecase_id) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/usecases/".concat(usecase_id, "/base-request/approve"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  RejectPendingBaseRequest: function RejectPendingBaseRequest(usecase_id) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/usecases/".concat(usecase_id, "/base-request/reject"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  extendDateValidity: function extendDateValidity() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var project_id = arguments.length > 1 ? arguments[1] : undefined;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/update-date-sandbox/".concat(project_id), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  deleteResourcesDataset: function deleteResourcesDataset(project_id) {
    var login = loginObj();
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.delete("/api/v1/attribute-management/".concat(project_id, "/delete-resources-dataset"), {
      data: body,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  deleteBase: function deleteBase() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var project_id = arguments.length > 1 ? arguments[1] : undefined;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/delete-base/".concat(project_id), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  pausesUsecase: function pausesUsecase(id) {
    var login = loginObj();
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/productivized-usecases/".concat(id, "/deactivate"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getTablesAWS: function getTablesAWS(business_unit) {
    var is_read = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return appApisGTW.get("/api/v1/attribute-management/aws-get-tables/business_unit/".concat(business_unit, "?is_read=").concat(is_read)).then(function (response) {
      return response.data;
    });
  },
  getColumnsAWS: function getColumnsAWS(business_unit, table_name, usecase_name) {
    var is_read = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return appApisGTW.get("/api/v1/attribute-management/business_unit/".concat(business_unit, "/usecase_name/").concat(usecase_name, "/tables/").concat(table_name, "/columns?is_read=").concat(is_read)).then(function (response) {
      return response.data;
    });
  },
  postConvertPartyIdAWS: function postConvertPartyIdAWS() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/aws-convert-partyid", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  postConvertIdsandboxAWS: function postConvertIdsandboxAWS() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/aws-convert-idsandbox", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  getInternalAttributesByUsecaseId: function getInternalAttributesByUsecaseId(useCaseId, lastVersionId) {
    var login = loginObj();
    return appApisGTW.get("/api/v1/attribute-management/usecase/".concat(useCaseId, "/lastVersion/").concat(lastVersionId, "/internal-attributes"), {
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        login: login
      }
    }).then(function (response) {
      return response.data;
    });
  },
  switchOwnerUseCase: function switchOwnerUseCase() {
    var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var useCaseId = arguments.length > 1 ? arguments[1] : undefined;
    var login = loginObj();
    var data = _objectSpread({
      login: login
    }, body);
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/change_owner_usecase/usecase/".concat(useCaseId), data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  observedUsecase: function observedUsecase(id) {
    var login = loginObj();
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/productivized-usecases/".concat(id, "/observed"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postUpdateProductizeScript: function postUpdateProductizeScript() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var automate_id = arguments.length > 1 ? arguments[1] : undefined;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/attr-automate-script-update/".concat(automate_id), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getStatisticsFields: function getStatisticsFields(data) {
    var login = loginObj();
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/statistics-fields", {
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getTablesSchemaAws: function getTablesSchemaAws() {
    return appApisGTW.get("/api/v1/attribute-management/get_table_schema_aws").then(function (response) {
      return response.data;
    });
  },
  getBucketByArea: function getBucketByArea(area_name) {
    return appApisGTW.get("/api/v1/attribute-management/attr-buckets-by-area/".concat(area_name)).then(function (response) {
      return response.data;
    });
  },
  createAttributeAutomation: function createAttributeAutomation(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post('/api/v1/attribute-management/attribute-automation/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getAttributeAutomations: function getAttributeAutomations(params) {
    var login = loginObj();
    return appApisGTW.get('/api/v1/attribute-management/attribute-automation/list', {
      params: params,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        login: login
      }
    }).then(function (response) {
      return response.data;
    });
  },
  deactivateAttributeAutomation: function deactivateAttributeAutomation(automationId) {
    var login = loginObj();
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/deactivate"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      throw error;
    });
  },
  // Cambio manual de estado (override admin auditable, RN-ATTR-024). Solo reconcilia la
  // fila: el backend cambia status_id y registra el log, no dispara pipeline ni post-pipeline.
  // Destinos válidos: 2 (Error), 12 (En ejecución), 14 (Ejecutado).
  changeAttributeAutomationStatus: function changeAttributeAutomationStatus(automationId) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      status_id = _ref.status_id,
      reason = _ref.reason;
    var login = loginObj();
    var body = {
      login: login,
      status_id: status_id,
      reason: reason
    };
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/status"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      throw error;
    });
  },
  // Fase 4 + 8 — Hard delete de automatizaciones type_export_id=5. Llamado desde la vista
  // admin (modo Todas) por usuarios ATTRIBUTE_ADMIN. Body: { reason, force, login }.
  hardDeleteAttributeAutomation: function hardDeleteAttributeAutomation(automationId) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      reason = _ref2.reason,
      _ref2$force = _ref2.force,
      force = _ref2$force === void 0 ? false : _ref2$force,
      _ref2$resume_from = _ref2.resume_from,
      resume_from = _ref2$resume_from === void 0 ? null : _ref2$resume_from,
      _ref2$skip_steps = _ref2.skip_steps,
      skip_steps = _ref2$skip_steps === void 0 ? [] : _ref2$skip_steps;
    var login = loginObj();
    // `deleted_by` lo deriva el backend de login.email; no se envía por separado.
    // `resume_from` / `skip_steps` permiten reintentar un borrado parcial (207) desde el
    // paso que falló, o saltarlo, sin repetir lo ya borrado.
    var body = {
      login: login,
      reason: reason,
      force: force,
      resume_from: resume_from,
      skip_steps: skip_steps
    };
    // skipErrorToast: el diálogo muestra el error adentro, con qué hacer; el aviso global
    // del interceptor lo taparía y duplicaría el mensaje.
    return appApisGTW.delete("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/hard-delete"), {
      headers: {
        'Content-Type': 'application/json'
      },
      data: body,
      skipErrorToast: true
    }).then(function (response) {
      return response.data;
    });
  },
  // Read-only: lista qué recursos se borrarían, para mostrarlos antes de confirmar.
  getHardDeletePreview: function getHardDeletePreview(automationId) {
    return appApisGTW.get("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/hard-delete-preview"), {
      headers: {
        'Content-Type': 'application/json'
      },
      skipErrorToast: true
    }).then(function (response) {
      return response.data;
    });
  },
  // Último intento de borrado (checklist tras un 207) y, en `in_progress`, el que sigue
  // corriendo: el diálogo lo consulta cada pocos segundos mientras espera el DELETE.
  getDeletionStatus: function getDeletionStatus(automationId) {
    return appApisGTW.get("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/deletion-status"), {
      headers: {
        'Content-Type': 'application/json'
      },
      skipErrorToast: true
    }).then(function (response) {
      return response.data;
    });
  },
  loadMonthsAttributeAutomation: function loadMonthsAttributeAutomation(automationId, data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/load-months"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  updateAutomationScript: function updateAutomationScript(automationId, data) {
    tasks.lockScreen.lock();
    return appApisGTW.patch("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/update-script"), data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      throw error;
    });
  },
  getActivityTimeline: function getActivityTimeline(automationId) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$page = _ref3.page,
      page = _ref3$page === void 0 ? 1 : _ref3$page,
      _ref3$page_size = _ref3.page_size,
      page_size = _ref3$page_size === void 0 ? 10 : _ref3$page_size;
    return appApisGTW.get("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/pipeline-status"), {
      headers: {
        'Content-Type': 'application/json'
      },
      params: {
        page: page,
        page_size: page_size
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getAutomationExecutions: function getAutomationExecutions(automationId) {
    return appApisGTW.get("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/executions"), {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  downloadAutomationScript: function downloadAutomationScript(automationId) {
    return appApisGTW.get("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/script"), {
      responseType: 'blob',
      headers: {
        Accept: 'application/sql,text/plain,application/octet-stream,application/json'
      }
    });
  },
  getPipelineStatusesCatalog: function getPipelineStatusesCatalog() {
    return appApisGTW.get('/api/v1/attribute-management/catalogs/pipeline-statuses', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  // Revisión de solicitudes Crear Atributo (status SOLICITADO): re-ejecuta la validación
  // IA de particiones. Si se pasa script_file/script_name/referenced_tables, valida ese script
  // en memoria (sin tocar S3). Si no, re-valida el script almacenado. Solo feedback visual.
  revalidateAutomationPartitions: function revalidateAutomationPartitions(automationId) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      script_file = _ref4.script_file,
      script_name = _ref4.script_name,
      referenced_tables = _ref4.referenced_tables;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, script_file ? {
      script_file: script_file,
      script_name: script_name || null,
      referenced_tables: referenced_tables || []
    } : {});
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/revalidate"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      throw error;
    });
  },
  // Aprobar (override admin) una solicitud SOLICITADO: lanza el pipeline.
  // Si se pasa script_file, el backend sube el script corregido a S3 antes de lanzar Lambda.
  // El admin tiene autoridad total: no hay validación de particiones en este endpoint.
  approveAutomation: function approveAutomation(automationId) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      reason = _ref5.reason,
      script_file = _ref5.script_file,
      script_name = _ref5.script_name;
    var login = loginObj();
    var body = _objectSpread({
      login: login,
      operator: window.userInfo.email,
      partition_validation_override_reason: reason || null
    }, script_file ? {
      script_file: script_file,
      script_name: script_name || null
    } : {});
    tasks.lockScreen.lock();
    return appApisGTW.post("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/approve"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      throw error;
    });
  },
  retryPipelineStep: function retryPipelineStep(automationId, step) {
    var login = loginObj();
    return appApisGTW.post("/api/v1/attribute-management/attribute-automation/".concat(automationId, "/retry-step"), {
      step: step,
      login: login
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  migrateUserEmail: function migrateUserEmail(payload) {
    var login = loginObj();
    tasks.lockScreen.lock();
    return appApisGTW.post('/api/v1/attribute-management/migrate-user-email', payload).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      throw error;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  }
};